// src/pages/AboutUs.jsx
import React, { useState, useEffect } from 'react';
import Header from '../components/navBar';
import Footer from '../components/footer';

const AboutUs = () => {
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const API_URL = `${backendURL}about-us/photos`;

  const [images, setImages] = useState({});

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(API_URL);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log("Fetched Images:", data); // Debugging
        setImages(data.images);
      } catch (err) {
        console.error('Error fetching images:', err);
      }
    };
  
    fetchImages();
  }, []);
  
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900">
      <Header />

      {/* Main About Section */}
      <main className="flex-1">
        <section className="py-16 sm:py-24 mx-auto max-w-screen-xl px-4 2xl:px-0">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white text-center mb-8">
            About Us
          </h1>
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-lg text-gray-700 dark:text-gray-300">
              Welcome to Brilyante, your trusted destination for exquisite jewelry.
              We specialize in providing a curated selection of fine jewelry including
              engagement rings, necklaces, earrings, bracelets, and more. Our mission is
              to provide the most affordable but highest quality diamond jewelry to our clients while maintaining ethical sourcing and
              exceptional customer service.
            </p>
            <p className="text-lg text-gray-700 dark:text-gray-300">
              At Brilyante, we believe in craftsmanship, authenticity, and innovation.
              Our team of experienced jewelers and designers are dedicated to creating
              pieces that are not only beautiful but also timeless in design. Every piece
              of jewelry we offer is crafted with attention to detail and a commitment to excellence.
            </p>
            <p className="text-lg text-gray-700 dark:text-gray-300">
              We are committed to sustainability and ethical sourcing. Our materials are
              carefully selected to ensure that every gem and metal used in our collections
              is sourced responsibly. With Brilyante, you can be confident that your purchase
              is not only a piece of art but also a symbol of ethical values.
            </p>
            <p className="text-lg text-gray-700 dark:text-gray-300">
              Thank you for choosing Brilyante. We invite you to explore our collections and
              experience the elegance and quality that set us apart. Whether you're celebrating
              a milestone or simply indulging in something beautiful, we're here to make every
              moment memorable.
            </p>
          </div>
        </section>

        {/* Craftsmanship Section */}
        <section className="bg-gray-50 dark:bg-gray-800 py-16">
          <div className="max-w-screen-xl mx-auto px-4 2xl:px-0">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
                Masterful Craftsmanship
              </h2>
              <p className="text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
                Discover the artistry behind every piece - where precision meets passion
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3, 4, 5, 6].map((num) => (
                <div key={num} className="relative group overflow-hidden rounded-lg">
                  <img
                    src={images[`image${num}`] || "https://via.placeholder.com/600x400"}
                    alt={`Craftsmanship example ${num}`}
                    className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  
                </div>
              ))}
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
};

export default AboutUs;
